/* Cayo Hueso - homepage intro overlay behaviour (markup: snippets/cayo-intro-overlay.liquid).
   Same staged fades as the password-page splash (logo 0.6s, tagline 3.0s, button 5.2s; 2.4s fades, 2.8s reel fade-in).
   Skip (visible from the start), Enter and Escape dismiss with a ~1s fade; overlay is then removed from the DOM,
   scroll is restored and focus moves to #MainContent. While up: body scroll locked, rest of the page inert, Tab trapped. */
(function () {
  'use strict';
  var el = document.getElementById('cayo-intro');
  if (!el || el.hidden || !el.parentNode) return;
  var doc = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var TIMING = { logo: 600, tagline: 3000, button: 5200 };
  var DISMISS_MS = reduce ? 200 : 1000;
  var done = false, reelCtl = null, timers = [];

  // Everything else on the page is inert while the overlay is up (focus + screen readers stay in the dialog).
  var inerted = [];
  Array.prototype.forEach.call(document.body.children, function (c) {
    if (c === el || c.tagName === 'SCRIPT' || c.hasAttribute('inert')) return;
    c.setAttribute('inert', ''); inerted.push(c);
  });

  // WebP -> PNG fallback for the logo
  Array.prototype.forEach.call(el.querySelectorAll('img[data-fallback]'), function (img) {
    img.addEventListener('error', function () { img.src = img.getAttribute('data-fallback'); }, { once: true });
  });

  // Staged fade-in (same schedule as the splash)
  var started = false;
  function startFades(immediate) {
    if (started) return; started = true;
    Array.prototype.forEach.call(el.querySelectorAll('.cayo-intro__fade'), function (f) {
      var t = immediate ? 0 : (TIMING[f.getAttribute('data-fade')] || 0);
      timers.push(setTimeout(function () { f.classList.add('is-in'); }, t));
    });
  }
  if (reduce) startFades(true);
  else {
    var fontsReady = (document.fonts && document.fonts.ready) ? document.fonts.ready : Promise.resolve();
    Promise.race([fontsReady, new Promise(function (r) { setTimeout(r, 1200); })]).then(function () {
      requestAnimationFrame(function () { if (!done) startFades(false); });
    });
  }

  // Reel: lazy-started after the page's own critical work, photos fetched at low priority.
  function startReel() {
    if (done || reelCtl || !window.CayoReel) return;
    var photos = [];
    try { photos = JSON.parse(document.getElementById('cayo-intro-reel-data').textContent); } catch (e) { photos = []; }
    reelCtl = window.CayoReel(document.getElementById('cayo-intro-reel'), photos, {
      speed: parseFloat(el.getAttribute('data-reel-speed')) || 40, lowPriority: true,
      onReady: function (ctl) { window.__cayoIntroReel = ctl; }
    });
  }
  var kick = function () { (window.requestIdleCallback || function (f) { return setTimeout(f, 1); })(startReel, { timeout: 600 }); };
  if (document.readyState === 'complete') kick(); else window.addEventListener('load', kick, { once: true });
  timers.push(setTimeout(startReel, 2500)); // never wait too long for slow third-party scripts

  function focusables() {
    return Array.prototype.filter.call(el.querySelectorAll('button, a[href]'), function (b) {
      return !b.disabled && getComputedStyle(b).visibility !== 'hidden' && b.offsetParent !== null;
    });
  }
  function dismiss() {
    if (done) return; done = true;
    el.classList.add('is-leaving');
    el.style.transitionDuration = DISMISS_MS + 'ms';
    setTimeout(remove, DISMISS_MS + 30);
  }
  function remove() {
    timers.forEach(clearTimeout);
    if (reelCtl) reelCtl.destroy();
    document.removeEventListener('keydown', onKey, true);
    if (el.parentNode) el.parentNode.removeChild(el);
    inerted.forEach(function (c) { c.removeAttribute('inert'); });
    doc.classList.remove('cayo-intro-open');
    var main = document.getElementById('MainContent');
    if (main && main.focus) main.focus({ preventScroll: true });
    window.__cayoIntroClosed = true;
    try { document.dispatchEvent(new CustomEvent('cayo:intro-closed')); } catch (e) {}
  }
  function onKey(e) {
    if (done) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); dismiss(); return; }
    if (e.key === 'Tab') {
      var f = focusables(); if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || !el.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !el.contains(a))) { e.preventDefault(); first.focus(); }
    }
  }
  document.addEventListener('keydown', onKey, true);
  Array.prototype.forEach.call(el.querySelectorAll('[data-cayo-intro-dismiss]'), function (b) { b.addEventListener('click', dismiss); });
  el.focus({ preventScroll: true });
  window.CayoIntro = { dismiss: dismiss, isOpen: function () { return !done; } };
})();
